<!--
Author: TangChen
Date: 2018-11-09
Desc: 用户持有银行卡信息组件，由index.js 配置引入
-->
<template>
    <div :class="'bizcomp-hold-bank bizcomp ' + className">
        <comp-title :title="title" />
        <el-row class="hold-bank-list" :gutter="10">
            <el-col v-for="(bank, index) in bankInfo" :key="index" :span="6">
                <el-card
                    class="bank-card"
                    :class="
                        bank.channelstatus !== '1'
                            ? colorBlue.indexOf(bank.bankcode) > -1
                                ? 'blue'
                                : 'red'
                            : ''
                    "
                >
                    <!-- 4.0 bank.hkopenflag返回的都是0，所以这里并不会展示，在增加线上卡的时候去添加汇款卡-->
                    <div v-if="$util.getConfig().hideFunc" class="hk">
                        <div
                            v-if="bank.hkopenflag === '1' && false"
                            class="cursor add-bank-btn"
                            v-on:click.prevent="addHK(bank)"
                        >
                            <el-tag type="info" color="white">
                                <span style="font-weight: bold">添加汇款卡</span>
                            </el-tag>
                        </div>
                    </div>
                    <div class="bank-info">
                        <div class="bank-img">
                            <img :src="$util.getImg(bank.bankcode)" alt="" />
                        </div>
                        <div class="bank-name">
                            <span class="t">{{ $cache.getDict("110080", bank.bankcode) }}</span>
                            <span class="c">
                                <span v-if="bank.paycenterid != '0001'">
                                    {{
                                        $cache.getDict("110079", bank.paycenterid) +
                                        (bank.hkcardflag === "1" ? "(汇款支付)" : "(在线支付)")
                                    }}
                                </span>
                                <span v-else>
                                    {{ $cache.getDict("110079", bank.paycenterid) }}
                                </span>
                            </span>
                        </div>
                    </div>
                    <p class="bank-num">
                        {{ $util.getNewCard(bank.depositcard) }}
                    </p>
                    <div v-if="$util.getConfig().hideFunc" class="bank-action">
                        <!--mod by zhangqc 20201122 汇款卡不支持签约解约-->
                        <!--<el-button
                            v-if="bank.allowsign==='1'&&bank.signstatus==='0'&&bank.authenticateflag!=='0'&&bank.hkcardflag!=='1'"
                            size="mini"
                            v-on:click.once="$router.push({name:'signbank',query:bank})"
                        >
                            签约
                        </el-button>
                        <el-button
                            v-if="bank.allowunsign==='0'&&bank.signstatus==='1'&&bank.authenticateflag!=='0'&&bank.hkcardflag!=='1'"
                            size="mini"
                            v-on:click.once="$router.push({name:'unsignbank',query:bank})"
                        >
                            解约
                        </el-button>-->
                        <el-button
                            v-if="
                                bank.paycenterid != '1000' &&
                                bank.authenticateflag === '0' &&
                                (bank.identifytype == '1' || bank.identifytype == '2')
                            "
                            size="mini"
                            v-on:click.once="
                                $router.push({
                                    name: 'activebank',
                                    query: bank
                                })
                            "
                        >
                            激活
                        </el-button>
                        <el-button
                            v-if="bank.authenticateflag === '2'"
                            size="mini"
                            v-on:click.once="
                                $router.push({
                                    name: 'modifybank',
                                    query: bank
                                })
                            "
                        >
                            修改
                        </el-button>
                        <!-- <el-button v-if="bank.authenticateflag==='1'&&bank.authenticateflag!=='0'" size="mini" v-on:click.once="$router.push({name:'changebank',query:bank})">
                            换卡
                        </el-button> -->
                        <el-button
                            size="mini"
                            v-on:click="deleteBank(bank.bankcardid, bank.paycenterid)"
                        >
                            删除
                        </el-button>
                    </div>
                </el-card>
            </el-col>
            <el-col :span="6">
                <el-card
                    v-if="!$util.getConfig().hideFunc && bankInfo.length === 0"
                    class="bank-card add"
                    :class="{ queryGrey: bankInfo.length === 0 }"
                >
                    <div>
                        <img class="no-card" src="@/assets/img/no-card.png" alt="" />
                        <p class="other">暂无可用银行卡</p>
                    </div>
                </el-card>
            </el-col>
            <el-col :span="6">
                <el-card
                    v-if="$util.getConfig().hideFunc"
                    class="bank-card add"
                    :class="{ grey: bankInfo.length === 0 }"
                >
                    <div v-on:click="$router.push({ name: 'addbank' })">
                        <i class="fa fa-plus-circle" aria-hidden="true" />
                        <p class="other">
                            {{ bankInfo.length === 0 ? "暂无可用，" : "" }}添加银行卡
                        </p>
                        <p class="more">支持多家银行卡</p>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <el-dialog
            title="银行卡删除"
            :visible.sync="dialogVisible"
            class="prop info-tips"
            width="480px"
        >
            <div class="investor-tips">
                <div class="prompt-info">
                    <p>
                        <i class="el-icon-warning" aria-hidden="true" />
                        <span>
                            此操作将永久删除该银行卡
                            {{ isPwdCheck ? "，输入交易密码进行删除" : "" }}！
                        </span>
                    </p>
                </div>
                <el-form
                    ref="ruleForm"
                    class="two-cols-form"
                    :model="ruleForm"
                    :rules="rules"
                    label-width="37px"
                    size="small"
                >
                    <el-form-item v-if="isPwdCheck" label="" prop="tradepwd">
                        <el-input
                            v-model="ruleForm.tradepwd"
                            type="password"
                            :maxlength="20"
                            placeholder="请输入交易密码"
                        />
                        <span
                            class="redemp-btn"
                            v-on:click.prevent="$router.push({ name: 'tradepwd' })"
                        >
                            <span class="like-a">忘记密码？</span>
                        </span>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button v-on:click="dialogVisible = false">取消</el-button>
                <el-button type="primary" v-on:click="deleteBankCon(deleteId, payCenterId)">
                    删除
                </el-button>
            </div>
        </el-dialog>
        <el-dialog title="添加汇款卡" :visible.sync="visible" class="prop info-tips" width="480px">
            <div class="investor-tips">
                <div class="prompt-info">
                    <p>
                        <i class="el-icon-warning" aria-hidden="true" />
                        <span>
                            是否添加{{ $cache.getDict("110080", hkId.bankcode) + "的汇款卡" }}！
                        </span>
                    </p>
                </div>
                <el-form
                    ref="ruleForm"
                    class="two-cols-form"
                    :model="ruleForm"
                    :rules="rules"
                    label-width="37px"
                    size="small"
                >
                    <el-form-item v-if="isPwdCheck" label="" prop="tradepwd">
                        <el-input
                            v-model="ruleForm.tradepwd"
                            type="password"
                            :maxlength="20"
                            placeholder="请输入交易密码"
                        />
                        <span
                            class="redemp-btn"
                            v-on:click.prevent="$router.push({ name: 'tradepwd' })"
                        >
                            <span class="like-a">忘记密码？</span>
                        </span>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button v-on:click="visible = false">取消</el-button>
                <el-button type="primary" v-on:click="addHKCon(hkId.bankcardid)">添加</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import userApi from "@/api/user";

export default {
    name: "HoldBank",
    mixins: [mixin],
    data() {
        return {
            bankInfo: [],
            dialogVisible: false,
            visible: false,
            isPwdCheck: false,
            hkId: "",
            isdellastcard: "",
            ruleForm: {
                tradepwd: ""
            },
            rules: {
                tradepwd: [
                    {
                        required: true,
                        message: "请输入交易密码",
                        trigger: "blur"
                    }
                ]
            },
            allowchange: "",
            deleteId: "",
            payCenterId: "",
            // 蓝色背景：建设银行、交通银行、民生银行、兴业银行、农业银行、@农村信用社、@浦发银行、@上海银行、@上海农商银行、@深圳银行、@杭州银行、@汉口银行、@中国银联
            colorBlue: "103,105,301,305,309,325,A40,310,325",
            paychannelInfoList: []
        };
    },
    mounted() {
        if (this.$cache.getBinded()) {
            this.getBankInfo();
        }
    },
    methods: {
        // 删除的银行卡
        deleteBank(id, payCenterId) {
            this.deleteId = id;
            this.payCenterId = payCenterId;
            this.dialogVisible = true;
            this.$util.queryValidPwdTrdMethod("0B6", (res) => {
                this.isPwdCheck = res;
                if (this.$refs.ruleForm) {
                    this.$refs.ruleForm.resetFields();
                }
            });
        },
        addHK(bank) {
            this.visible = true;
            this.hkId = bank;
            this.$util.queryValidPwdTrdMethod("0A3", (res) => {
                this.isPwdCheck = res;
                if (this.$refs.ruleForm) {
                    this.$refs.ruleForm.resetFields();
                }
            });
        },
        addHKCon(id) {
            const _this = this;
            this.$refs.ruleForm.validate(async (valid) => {
                if (valid) {
                    let _pwd = "";
                    if (_this.isPwdCheck) {
                        _pwd = _this.$util.enc(_this.ruleForm.tradepwd);
                    }
                    let isDecryptObj = {};
                    if (this.$cache.getIsEncrypted()) {
                        isDecryptObj.en_certificateno = this.$cache.getUser().en_certificateno;
                        isDecryptObj.en_depositname = this.$cache.getUser().en_custname;
                    } else {
                        isDecryptObj.certificateno = this.$cache.getUser().certificateno;
                        isDecryptObj.depositname = this.$cache.getUser().custname;
                    }
                    const res = await userApi.combBankCardCreate(
                        {
                            ...isDecryptObj,
                            tradepassword: _pwd,
                            depositcard: this.hkId.depositcard,
                            bankcode: this.hkId.bankcode,
                            certificatetype: this.$cache.getUser().certificatetype,
                            paychannel: "0001",
                            bankcardmobile: this.hkId.mobileno,
                            bankname: this.$cache.getDict("110080", this.hkId.bankcode),
                            branchinterbankcode: this.hkId.branchinterbankcode
                        },
                        this.$cache.getIsEncrypted()
                    );
                    if (res.code == "0") {
                        this.visible = false;
                        this.getBankInfo();
                        this.$message({
                            type: "success",
                            message: "增加汇款卡成功!"
                        });
                    }
                } else {
                    return false;
                }
            });
        },
        // 删除银行卡
        deleteBankCon(id, payCenterId) {
            const _this = this;
            this.$refs.ruleForm.validate(async (valid) => {
                if (valid) {
                    _this.dialogVisible = false;
                    let _pwd = "";
                    if (_this.isPwdCheck) {
                        _pwd = _this.$util.enc(_this.ruleForm.tradepwd);
                    }
                    const res = await userApi.delCardPayChannel({
                        bankcardid: id,
                        paychannel: payCenterId,
                        tradepassword: _pwd
                    });
                    if (res.code === "0") {
                        _this.dialogVisible = false;
                        _this.getBankInfo();
                        _this.$message({
                            type: "success",
                            message: "银行卡删除成功!"
                        });
                    }
                } else {
                    return false;
                }
            });
        },
        async getBankInfo() {
            const reqRes = await userApi.getMyBankCards();
            const res = reqRes.data;
            if (res.data) {
                this.bankInfo = res.data ? res.data : [];
                // 屏蔽汇款卡
                // this.bankInfo = this.bankInfo.filter((item) => {
                //     return item.paycenterid !== "0001";
                // });
                // 根据配置参数判断是否展示柜台的卡
                this.bankInfo = this.bankInfo.filter((item) => {
                    return this.$util.showCounterCard() || item.banktype != "1";
                });
                this.bankInfo.forEach((bankItem) => {
                    if (
                        bankItem.specialflagofchannel.indexOf("s") > -1 ||
                        bankItem.specialflagofchannel.indexOf("t") > -1
                    ) {
                        bankItem.identifytype = "1";
                    } else if (
                        bankItem.specialflagofchannel.indexOf("r") > -1 ||
                        bankItem.specialflagofchannel.indexOf("u") > -1
                    ) {
                        bankItem.identifytype = "2";
                    } else {
                        bankItem.identifytype = "0";
                    }
                });
            }
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
/* 用户持有银行卡信息 */
.bizcomp-hold-bank {
    overflow: hidden;
    .info-tips {
        .two-cols-form .el-form-item__content {
            .el-input {
                width: 70%;
            }
        }
        .prompt-info {
            .el-icon-warning {
                color: var(--color-primary);
                margin-right: 8px;
                font-size: $f24;
                vertical-align: middle;
            }
            span {
                vertical-align: middle;
            }
        }
    }
    .redemp-btn {
        margin-left: 3%;
    }
    .manage-bank {
        text-align: center;
        font-size: $f18;
        line-height: 30px;
        padding: 20px 0;
        border-top: 1px solid $border-color3;
    }
    .el-row.hold-bank-list {
        padding: 11px 25px 26px;
        .el-col .bank-card {
            cursor: pointer;
            position: relative;
            /*height: 128px;*/
            margin-top: 20px;
            border-radius: 4px;
            background-color: #a1a1a1;
            box-shadow: 0 1px 2px 1px #a1a1a1;
            color: $text-color6;
            border: none;
            .hk {
                position: absolute;
                right: 20px;
                top: 20px;
                font-size: 12px;
                line-height: 22px;
                .add-bank-btn {
                    margin-top: -15px;
                }
            }
            .bank-info {
                margin-bottom: 15px;
                .bank-img {
                    width: 44px;
                    height: 44px;
                    display: inline-block;
                    vertical-align: middle;
                    text-align: center;
                    border-radius: 100px;
                    background-color: $bg2;
                    padding: 7px;
                    box-sizing: border-box;
                    img {
                        width: 30px;
                        height: 30px;
                    }
                }
                .bank-name {
                    margin-left: 8px;
                    display: inline-block;
                    vertical-align: middle;
                    span {
                        display: block;
                        &.t {
                            font-size: $f16;
                        }
                    }
                }
            }
            .bank-num {
                font-size: $f18;
            }
            &.blue {
                background-color: $color-b-l;
                box-shadow: 0 1px 2px 1px $color-b-l;
                .bank-action .el-button {
                    background-color: $color-b-l;
                }
            }
            &.red {
                background-color: $color-c-m;
                box-shadow: 0 1px 2px 1px $color-c-m;
                .bank-action .el-button {
                    background-color: $color-c-m;
                }
            }
            &.add {
                &.grey {
                    background-color: #a1a1a1;
                    box-shadow: 0 1px 2px 1px #a1a1a1;
                }
                &.queryGrey {
                    background-color: rgb(216, 221, 230);
                    box-shadow: 0 1px 2px 1px rgb(216, 221, 230);
                }

                background-color: $color-a-s;
                box-shadow: 0 1px 2px 1px $color-a-s;
                text-align: center;
                i {
                    font-size: 44px;
                    line-height: 44px;
                }
                .no-card {
                    width: 36px;
                    height: 36px;
                    border-radius: 50%;
                }
                p.other {
                    font-size: $f18;
                    margin-top: 10px;
                    line-height: 30px;
                }
                p.more {
                    line-height: 32px;
                }
            }
            .bank-action {
                padding-top: 10px;
                text-align: center;
                .el-button--default {
                    padding: 6px 10px;
                    color: $text-color6;
                    background-color: inherit;
                    border-color: $text-color6;
                    &:hover {
                        color: $color-a-s;
                        border-color: $color-a-s;
                    }
                }
            }
        }
    }
}
</style>
